import { useEffect, useRef, useState } from "react";
import { Search, User, Briefcase } from "lucide-react";
import { useApi } from "@/lib/api";
import { Input } from "@/components/ui/input";

// CRM search with live suggestions (contacts + opportunities of this tenant): debounced, arrow keys / Enter / Escape, click to pick.
export default function SearchSuggest({ tid, value, onChange, onPick, kinds = null, testid = "sheet-search", placeholder = "Cerca nome, email, azienda, trattativa", width = "w-[240px]" }) {
  const api = useApi();
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [hi, setHi] = useState(-1);
  const seq = useRef(0);
  useEffect(() => {
    const q = value.trim();
    if (q.length < 2) { setItems([]); return undefined; }
    const n = ++seq.current;
    const t = setTimeout(() => api.get(`/t/${tid}/crm/suggest`, { params: { q } }).then(({ data }) => { if (n === seq.current) { setItems(kinds ? data.filter((x) => kinds.includes(x.kind)) : data); setHi(-1); } }).catch(() => {}), 200);
    return () => clearTimeout(t);
  }, [api, tid, value]);
  const pick = (x) => { setShow(false); onPick(x); };
  const key = (e) => {
    if (!show || !items.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setHi((i) => (i + 1) % items.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setHi((i) => (i <= 0 ? items.length - 1 : i - 1)); }
    else if (e.key === "Enter" && hi >= 0) { e.preventDefault(); pick(items[hi]); }
    else if (e.key === "Escape") setShow(false);
  };
  const open = show && items.length > 0;
  return (
    <div className="relative">
      <Search size={14} className="absolute left-2.5 top-2.5 text-slate-400" />
      <Input value={value} onChange={(e) => { onChange(e.target.value); setShow(true); }} onFocus={() => setShow(true)} onBlur={() => setTimeout(() => setShow(false), 150)} onKeyDown={key}
        placeholder={placeholder} className={`h-9 ${width} bg-white pl-8 text-xs`} role="combobox" aria-expanded={open} aria-autocomplete="list" data-testid={testid} />
      {open && (
        <ul role="listbox" className="absolute left-0 top-10 z-30 w-[320px] overflow-hidden rounded-md border bg-white py-1 shadow-lg" data-testid={`${testid}-list`.replace("sheet-search-list", "sheet-suggest-list")}>
          {items.map((x, i) => (
            <li key={`${x.kind}-${x.id}`} role="option" aria-selected={i === hi} onMouseDown={(e) => { e.preventDefault(); pick(x); }} onMouseEnter={() => setHi(i)}
              className={`flex cursor-pointer items-center gap-2 px-3 py-1.5 text-xs ${i === hi ? "bg-sky-50" : ""}`} data-testid={`${testid === "sheet-search" ? "sheet-suggest" : testid}-${x.kind}-${x.id}`}>
              {x.kind === "deal" ? <Briefcase size={13} className="shrink-0 text-slate-400" /> : <User size={13} className="shrink-0 text-slate-400" />}
              <span className="min-w-0 flex-1 truncate"><b className="font-medium text-slate-800">{x.label}</b>{x.sub && <span className="text-slate-500"> · {x.kind === "deal" ? `trattativa di ${x.sub}` : x.sub}</span>}</span>
            </li>))}
        </ul>)}
    </div>
  );
}
